export const CREATOR_PROFILE_VARS = [
  "avg_views",
  "followers",
  "avg_eng_rate",
  "avg_likes",
  "median_views",
] as const;

/**
 * Extract variable names from a formula expression.
 * Matches identifier-like tokens (letters, digits, underscores starting with letter/underscore).
 * Returns deduplicated list.
 */
export function extractFormulaVariables(expression: string): string[] {
  if (!expression || !expression.trim()) return [];
  const tokens = expression.match(/[a-zA-Z_]\w*/g);
  if (!tokens) return [];
  return [...new Set(tokens)];
}
